import { Configuration } from "../../../Components/Configuration";
import { HtmlController } from "../../../HTMLComponents/HtmlController";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { AppContext } from "../../../../Common/AppContext";
import { UriHelper } from "neo-common";
import { GameApp } from "../../../GameApp";
import { Platforms } from "neo-games";

export class SimilarGames {
    public enabled: boolean = false;

    private _holder: HTMLElement;
    private _pagesHolder: HTMLElement;
    private _pagingHolder: HTMLElement;
    private _pages: Array<HTMLElement> = [];
    private _paging: Array<HTMLElement> = [];
    private _actualPage: number = 0;

    constructor() {}

    initialize(): void {
        if (
            AppContext != null &&
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.ShowSimilarGames &&
            AppContext.gameConfiguration.StaticContentUrl !== "" &&
            this.getSimilarGamesList().length > 0
        ) {
            this._holder = document.getElementById("similarGames");
            this._pagesHolder = document.getElementById("similarGamesPagesContainer");
            this._pagingHolder = document.getElementById("similarGamesPaging");

            if (this._holder != null && this._pagesHolder != null) {
                this.createPages();
                this.enabled = true;
            }
        }
    }

    private getSimilarGamesList(): Array<string> {
        if (
            AppContext != null &&
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.SimilarGamesList.length > 0
        ) {
            return AppContext.gameConfiguration.SimilarGamesList.filter((e) => e !== GameApp.key);
        }

        return [];
    }

    private createPages(): void {
        if (AppContext != null && AppContext.gameConfiguration != null && this.getSimilarGamesList().length > 0) {
            let filterArray: Array<string> = this.getSimilarGamesList();
            let page: number = 0;
            for (let i: number = 0; i < filterArray.length; i++) {
                if (i % 15 === 0) {
                    page = this.createNextPage();
                }
                this.createPageItem(filterArray[i], page);
            }
        }

        if (this._pages.length > 1) {
            let prewPageButton: HTMLElement = document.getElementById("similarGamesPrewArrow");
            let nextPageButton: HTMLElement = document.getElementById("similarGamesNextArrow");
            if (prewPageButton != null) {
                prewPageButton.classList.remove("_hidden");
                prewPageButton.onclick = this.prewPage.bind(this);
            }
            if (nextPageButton != null) {
                nextPageButton.classList.remove("_hidden");
                nextPageButton.onclick = this.nextPage.bind(this);
            }
            if (this._pagingHolder != null) {
                this._pagingHolder.classList.remove("_hidden");
            }
        }

        const exitBtn = document.getElementById("exitBtn");
        if (exitBtn != null) {
            if (
                AppContext != null &&
                AppContext.gameConfiguration != null &&
                AppContext.gameConfiguration.ShowExitGameButton
            ) {
                exitBtn.classList.remove("_hidden");
            } else {
                exitBtn.classList.add("_hidden");
            }
        }
    }

    private createNextPage(): number {
        let newPage: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let newPageChild: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let newPaging: HTMLDivElement = <HTMLDivElement>document.createElement("div");

        newPage.classList.add("similarGamesPage");
        newPageChild.classList.add("customContent");
        newPaging.classList.add("similarGamesPageNumber");

        if (this._pages.length === 0) {
            newPage.classList.add("_active");
            newPaging.classList.add("_active");
        } else {
            newPage.classList.add("_disabled");
        }

        newPage.appendChild(newPageChild);

        this._pages.push(newPage);
        this._paging.push(newPaging);
        if (this._pagesHolder != null) {
            this._pagesHolder.appendChild(newPage);
        }
        if (this._pagingHolder != null) {
            this._pagingHolder.appendChild(newPaging);
        }

        return this._pages.length - 1;
    }

    private createPageItem(name: string, page: number): void {
        let itemHolder: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let item: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let itemLoading: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let itemLoadingIcon: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let itemLogo: HTMLDivElement = <HTMLDivElement>document.createElement("div");

        itemHolder.classList.add("similarGameContainer");
        item.classList.add("similarGameItem");
        itemLoading.classList.add("similarGameLoading");
        itemLoadingIcon.classList.add("loadingIcon");
        itemLogo.classList.add("similarGameLogo");
        itemLogo.setAttribute("game", name);

        let img = document.createElement("img");
        img.setAttribute(
            "src",
            AppContext.gameConfiguration.StaticContentUrl + name + "/" + window["QUALITY"] + "/logo.jpg",
        );
        img.addEventListener("load", this.setItemLogo.bind(this, itemLogo, itemLoading, name));

        itemHolder.appendChild(item);
        item.appendChild(itemLoading);
        itemLoading.appendChild(itemLoadingIcon);
        item.appendChild(itemLogo);
        itemLogo.onclick = this.selectGame.bind(this);

        if (this._pages[page] != null) {
            this._pages[page].firstChild.appendChild(itemHolder);
        }
    }

    private setItemLogo(itemLogo: HTMLDivElement, itemLoading: HTMLDivElement, name: string): void {
        itemLoading.parentNode.removeChild(itemLoading);
        itemLogo.style.background =
            "url(" + AppContext.gameConfiguration.StaticContentUrl + name + "/" + window["QUALITY"] + "/logo.jpg)";
    }

    private prewPage(): void {
        if (!this.enabled) {
            return;
        }
        PlayList.play("SND_Click");
        this.disableAllPages();
        this._actualPage--;
        if (this._pages[this._actualPage] == null) {
            this._actualPage = this._pages.length - 1;
        }
        if (this._pages[this._actualPage] != null) {
            this._pages[this._actualPage].classList.remove("_disabled");
            this._pages[this._actualPage].classList.add("_active");
        }
        if (this._paging[this._actualPage] != null) {
            this._paging[this._actualPage].classList.add("_active");
        }
    }

    private nextPage(): void {
        if (!this.enabled) {
            return;
        }
        PlayList.play("SND_Click");
        this.disableAllPages();
        this._actualPage++;
        if (this._pages[this._actualPage] == null) {
            this._actualPage = 0;
        }
        if (this._pages[this._actualPage] != null) {
            this._pages[this._actualPage].classList.remove("_disabled");
            this._pages[this._actualPage].classList.add("_active");
        }
        if (this._paging[this._actualPage] != null) {
            this._paging[this._actualPage].classList.add("_active");
        }
    }

    private disableAllPages(): void {
        if (!this.enabled) {
            return;
        }
        for (let i: number = 0; i < this._pages.length; i++) {
            if (this._pages[i].classList.contains("_active")) {
                this._pages[i].classList.remove("_active");
            }
            if (!this._pages[i].classList.contains("_disabled")) {
                this._pages[i].classList.add("_disabled");
            }
        }

        for (let i: number = 0; i < this._paging.length; i++) {
            if (this._paging[i].classList.contains("_active")) {
                this._paging[i].classList.remove("_active");
            }
        }
    }

    private selectGame(e: any): void {
        if (!this.enabled) {
            return;
        }
        PlayList.play("SND_Click");
        if (e != null && e.target != null && e.target.hasAttribute("game")) {
            let urlInfo: Object = UriHelper.parseUrl(window.location.href, true, true);

            if (urlInfo != null && urlInfo["query"]["serverUrl"] && urlInfo["hash"]) {
                let serverUrl: string = urlInfo["query"]["serverUrl"];
                let token: string = urlInfo["hash"].substring(1);
                let newUrl: string = serverUrl + "Launch/" + e.target.getAttribute("game") + "?" + token;
                let root: HTMLElement = document.getElementById("root");
                if (root != null) {
                    root.style.display = "none";
                }

                Platforms.Platforms.gameChange(e.target.getAttribute("game"));
                if (Platforms.Platforms.handleChangeGame) {
                    return;
                }

                // GameApp.gameClient.leaveGame(); //game session will move to selected game, so we dont need to kill it
                setTimeout(() => {
                    window.location.replace(newUrl);
                }, 100);
            }
        }
    }

    public open(): boolean {
        if (this.enabled) {
            if (this._holder.classList.contains("_disabled")) {
                this._holder.classList.remove("_disabled");
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    public disable(): void {
        if (!this.enabled) {
            return;
        }
        if (!this._holder.classList.contains("_disabled")) {
            this._holder.classList.add("_disabled");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/SimilarGames/SimilarGames.ts
 **/